import gql from "graphql-tag";
const GET_ME = gql `
  query getMe {
    me {
      firstName
      isAdmin
      isEditor
      isSocials
      username
    }
  }
`;
export default GET_ME;
